export default "__VITE_ASSET__415eae10__"